export default __webpack_public_path__ + "static/media/stats3.789315dc.png";